import { defineMessages } from 'react-intl';

const messages = defineMessages({
  pets: {
    id: 'App.Household.PetsSection.Pets',
    defaultMessage: 'Pets',
  },
  name: {
    id: 'App.Household.PetsSection.Name',
    defaultMessage: 'Name',
  },
  petType: {
    id: 'App.Household.PetsSection.PetType',
    defaultMessage: 'Pet',
  },
  petBreed: {
    id: 'App.Household.PetsSection.PetBreed',
    defaultMessage: 'Type',
  },
  weight: {
    id: 'App.Household.PetsSection.Weight',
    defaultMessage: 'Weight',
  },
  petTag: {
    id: 'App.Household.PetsSection.PetTag',
    defaultMessage: 'Pet Tag',
  },
  serviceAnimal: {
    id: 'App.Household.PetsSection.ServiceAnimal',
    defaultMessage: 'Service Animal',
  },
  status: {
    id: 'App.Household.PetsSection.Status',
    defaultMessage: 'Status',
  },
  startDate: {
    id: 'App.Household.PetsSection.StartDate',
    defaultMessage: 'Start Date',
  },
  endDate: {
    id: 'App.Household.PetsSection.EndDate',
    defaultMessage: 'End Date',
  },
  noPets: {
    id: 'App.Household.PetsSection.NoPets',
    defaultMessage: 'No pets',
  },
  petsLoadError: {
    id: 'App.Household.PetsSection.PetsLoadError',
    defaultMessage: 'Unable to load pets.',
  },
  yes: {
    id: 'App.Household.PetsSection.Yes',
    defaultMessage: 'yes',
  },
  no: {
    id: 'App.Household.PetsSection.No',
    defaultMessage: 'no',
  },
});

export default messages;
